import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { catchError, map, Observable, of } from 'rxjs';
import { Five9TranscriptMessage, PaginateQuery, PaginateResult } from '../core/models';

@Injectable({ providedIn: 'root' })
export class CustomerConversationService extends ApiService {
  constructor(http: HttpClient) {
    super(http, 'Customer');
  }

  public override paginate(data: PaginateQuery): Observable<PaginateResult> {
    return this.http.post<PaginateResult>(this.route() + '/paginateConversations', data).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403) {
          return of({ total: 0, list: [] });
        } else {
          throw error;
        }
      })
    );
  }

  public paginateFive9(data: PaginateQuery): Observable<PaginateResult> {
    return this.http.post<PaginateResult>(this.route() + '/PaginateConversationsFive9', data).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403) {
          return of({ total: 0, list: [] });
        } else {
          throw error;
        }
      })
    );
  }

  public getFive9Transcript(transcriptId: string | null | undefined): Observable<Five9TranscriptMessage[]> {
    const id = transcriptId?.trim();
    if (!id) {
      return of([]);
    }

    const params = new HttpParams().set('transcriptId', id);
    return this.http.get<Five9TranscriptMessage[]>(this.route() + '/Five9Transcript', { params });
  }

  public getFive9TranscriptFromUrl(transcriptUrl: string | null | undefined): Observable<Five9TranscriptMessage[]> {
    const url = transcriptUrl?.trim();
    if (!url) {
      return of([]);
    }

    return this.http.get(url, { responseType: 'text' }).pipe(map((content) => this.parseFive9TranscriptJsonLines(content)));
  }

  private parseFive9TranscriptJsonLines(content: string): Five9TranscriptMessage[] {
    return (content || '')
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter(Boolean)
      .map((line) => JSON.parse(line) as Five9TranscriptMessage)
      .filter((message) => message !== null);
  }
}
